import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  const { clear } = useCart();

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return undefined; }
    let n = 0, stop = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { clear(); return setState("paid"); }
        if (["expired", "failed"].includes(data.payment_status)) return setState("error");
      } catch { return setState("error"); }
      if (!stop && ++n < 15) setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
    return () => { stop = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mx-auto max-w-lg px-6 py-32 text-center" data-testid="payment-success-page">
      {state === "checking" && <><Loader2 className="w-12 h-12 mx-auto animate-spin text-brand" /><p className="mt-6" data-testid="payment-checking">Confirmando tu pago…</p></>}
      {state === "paid" && (
        <>
          <CheckCircle2 className="w-16 h-16 mx-auto text-emerald-500" />
          <h1 className="mt-6 font-heading text-4xl font-black uppercase tracking-tight" data-testid="payment-confirmed">¡Pedido confirmado!</h1>
          <p className="mt-4 text-slate-600">Gracias por comprar en Sobrino Sport. Te hemos enviado un email con el resumen y el número de tu pedido.</p>
          <div className="mt-8 flex justify-center gap-3">
            <Link to="/tienda" className="btn-primary" data-testid="success-continue">Seguir comprando</Link>
            <Link to="/cuenta" className="btn-outline" data-testid="success-orders">Mis pedidos</Link>
          </div>
        </>
      )}
      {(state === "error" || state === "timeout") && (
        <>
          <XCircle className="w-16 h-16 mx-auto text-rose-500" />
          <p className="mt-6" data-testid="payment-error">{state === "timeout" ? "Tu pago aún se está procesando. Revisa tu email en unos minutos." : "No hemos podido confirmar el pago."}</p>
          <Link to="/checkout" className="btn-primary mt-8 inline-flex">Volver</Link>
        </>
      )}
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="mx-auto max-w-lg px-6 py-32 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-16 h-16 mx-auto text-slate-400" />
      <h1 className="mt-6 font-heading text-4xl font-black uppercase tracking-tight">Pago cancelado</h1>
      <p className="mt-4 text-slate-600">No se ha realizado ningún cargo. Tu carrito sigue guardado.</p>
      <Link to="/checkout" className="btn-primary mt-8 inline-flex" data-testid="cancel-back-checkout">Volver al pago</Link>
    </div>
  );
}
